var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('swiper',{attrs:{"options":{
    autoplay: true,
    pagination: {
        el: '.j_swiper-pagination',
        clickable: true
    }
}}},[_vm._l((_vm.items),function(item,index){return _c('SwiperSlide',{key:index},[_c('a',{staticClass:"block",attrs:{"href":item.url,"title":item.title,"target":item.target}},[_c('img',{staticClass:"rounded object-cover",attrs:{"alt":item.title,"src":item.path_url}})])])}),_vm._v(" "),_c('div',{staticClass:"j_swiper-pagination swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }